module.exports = __webpack_public_path__ + "static/steven-fb9f2ab91011c70f92123d031346465a.jpg";